import React from 'react';
import { TOOLTIP_PREFIX_CLS } from '@antv/s2';

export const Divider = () => {
  return <div className={`${TOOLTIP_PREFIX_CLS}-divider`} />;
};
